<template>
  <v-bottom-navigation
    class="bottom-navigation"
    fixed
    v-model="value"
    color="teal"
    grow
  >
    <v-btn :height="80" @click="$router.push('/')">
      <template v-if="value == 0">
        <div class="active-menu">
          <v-img
            max-height="90"
            max-width="90"
            src="../../public/image/bar/home_active.png"
          ></v-img>
        </div>

        <span class="mt-8">{{ $vuetify.lang.t("$vuetify.public.home") }}</span>
      </template>
      <template v-else>
        <span class="nat-span mt-3">{{
          $vuetify.lang.t("$vuetify.public.home")
        }}</span>
        <v-img
          max-height="22"
          max-width="22"
          :src="$vuetify.theme.dark ? icons.home_dark : icons.home_light"
        ></v-img>
      </template>
    </v-btn>

    <v-btn :height="80" @click="$router.push('/market')">
      <template v-if="value == 1">
        <div class="active-menu">
          <v-img
            max-height="90"
            max-width="90"
            src="../../public/image/bar/market_active.png"
          ></v-img>
        </div>

        <span class="mt-8">{{
          $vuetify.lang.t("$vuetify.setting.markets")
        }}</span>
      </template>
      <template v-else>
        <span class="nat-span mt-3">{{
          $vuetify.lang.t("$vuetify.setting.markets")
        }}</span>
        <v-img
          max-height="22"
          max-width="22"
          :src="$vuetify.theme.dark ? icons.market_dark : icons.market_light"
        ></v-img>
      </template>
    </v-btn>

    <v-btn :height="80" @click="$router.push('/delivery')">
      <template v-if="value == 2">
        <div class="active-menu">
          <v-img
            max-height="90"
            max-width="90"
            src="../../public/image/bar/delivery_active.png"
          ></v-img>
        </div>

        <span class="mt-8">{{
          $vuetify.lang.t("$vuetify.setting.dreivatives")
        }}</span>
      </template>
      <template v-else>
        <span class="nat-span mt-3">{{
          $vuetify.lang.t("$vuetify.setting.dreivatives")
        }}</span>
        <v-img
          max-height="22"
          max-width="22"
          :src="
            $vuetify.theme.dark ? icons.delivery_dark : icons.delivery_light
          "
        ></v-img>
      </template>
    </v-btn>
    <v-btn :height="80" @click="$router.push('/contract')">
      <template v-if="value == 3">
        <div class="active-menu">
          <v-img
            max-height="90"
            max-width="90"
            src="../../public/image/bar/contract_active.png"
          ></v-img>
        </div>

        <span class="mt-8">{{
          $vuetify.lang.t("$vuetify.setting.standardConteact")
        }}</span>
      </template>
      <template v-else>
        <span class="nat-span mt-3">{{
          $vuetify.lang.t("$vuetify.setting.standardConteact")
        }}</span>
        <v-img
          max-height="22"
          max-width="24"
          :src="
            $vuetify.theme.dark ? icons.contract_dark : icons.contract_light
          "
        ></v-img>
      </template>
    </v-btn>
    <v-btn :height="80" @click="$router.push('/assets')">
      <template v-if="value == 4">
        <div class="active-menu">
          <v-img
            max-height="90"
            max-width="90"
            src="../../public/image/bar/assets_active.png"
          ></v-img>
        </div>
        <span class="mt-8">{{
          $vuetify.lang.t("$vuetify.setting.assets")
        }}</span>
      </template>
      <template v-else>
        <span class="nat-span mt-3">{{
          $vuetify.lang.t("$vuetify.setting.assets")
        }}</span>
        <v-img
          max-height="22"
          max-width="30"
          :src="$vuetify.theme.dark ? icons.assets_dark : icons.assets_light"
        ></v-img>
      </template>
    </v-btn>
  </v-bottom-navigation>
</template>
<script>
import home_dark from "../../public/image/bar/home.png";
import home_light from "../../public/image/bar/home_light.png";
import market_dark from "../../public/image/bar/market.png";
import market_light from "../../public/image/bar/market_light.png";
import delivery_dark from "../../public/image/bar/trade.png";
import delivery_light from "../../public/image/bar/trade_light.png";
import contract_dark from "../../public/image/bar/contract.png";
import contract_light from "../../public/image/bar/contract_light.png";
import assets_dark from "../../public/image/bar/assets.png";
import assets_light from "../../public/image/bar/assets_light.png";
export default {
  data() {
    return {
      value: 0,
      icons: {
        home_dark,
        home_light,
        market_dark,
        market_light,
        delivery_dark,
        delivery_light,
        contract_dark,
        contract_light,
        assets_dark,
        assets_light,
      },
    };
  },
  mounted() {
    if (this.$route.path == "/") {
      this.value = 0;
    } else if (this.$route.path == "/market") {
      this.value = 1;
    } else if (this.$route.path == "/delivery") {
      this.value = 2;
    } else if (this.$route.path == "/contract") {
      this.value = 3;
    } else if (this.$route.path == "/assets") {
      this.value = 4;
    } else {
      this.value = 0;
    }
  },
  watch: {
    $route(v) {
      if (v.path == "/") {
        this.value = 0;
      } else if (v.path == "/market") {
        this.value = 1;
      } else if (v.path == "/delivery") {
        this.value = 2;
      } else if (v.path == "/contract") {
        this.value = 3;
      } else if (v.path == "/assets") {
        this.value = 4;
      } else {
        this.value = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bottom-navigation {
  //   position: relative;
  background-color: var(--v-navigation_bg-base);
  .active-menu {
    position: fixed;
    bottom: 13px;
  }
  .v-btn--has-bg {
    background-color: var(--v-navigation_bg-base);
  }
}
.v-bottom-navigation {
  height: 80px !important;
  border-radius: 30px 30px 0 0;
  overflow: hidden;
  .nat-span {
    color: var(--v-secondary-base);
  }
}
</style>